import React from 'react';
import { useSelector } from 'react-redux';
import {
  selectAllProjects,
  selectLastVisitedId,
} from 'core/features/projects/projectsSlice';
import { selectIstGesichert } from 'core/features/sicherheit/sicherheitSlice';
import ProjectCircle from 'core/components/ProjectCircle';
import PageBackground from 'core/components/PageBackground';
import UserMenu from 'core/components/UserMenu';
import SicherheitPanel from 'core/features/sicherheit/SicherheitPanel';
import { MODULES } from 'modules';

/**
 * Übersichtsseite des Portals.
 * Zeigt oben das Panel für den gesicherten Modus, darunter alle Projekte als
 * klickbare Kreise (gespeist aus dem Redux-Store) sowie die Portal-Widgets, die
 * Module optional mitliefern (portalWidgets). Gesicherte Projekte (secured)
 * erscheinen nur im entsperrten Zustand.
 */
export default function OverviewPage() {
  const alleProjekte = useSelector(selectAllProjects);
  const lastVisitedId = useSelector(selectLastVisitedId);
  const istGesichert = useSelector(selectIstGesichert);
  const portalWidgets = MODULES.flatMap((modul) => modul.portalWidgets || []);

  // Gesicherte Bereiche nur im entsperrten Modus anzeigen.
  const projects = alleProjekte.filter((p) => !p.secured || istGesichert);

  return (
    <div className="mx-auto max-w-6xl px-4 py-10 sm:px-6 sm:py-16">
      <PageBackground name="overview" />
      <div className="absolute right-4 top-4 sm:right-6 sm:top-6">
        <UserMenu />
      </div>
      <section className="animate-fade-in-up">
        <div className="mb-10 mt-12 text-center sm:mb-14 sm:mt-0">
          <p className="mb-3 font-mono text-xs uppercase tracking-[0.2em] text-ink-muted">
            Projekt-Portal
          </p>
          <h1 className="font-serif text-4xl font-semibold tracking-tight text-ink sm:text-5xl">
            Willkommen zurück
          </h1>
          <p className="mx-auto mt-4 max-w-xl text-ink-soft">
            Wähle ein Projekt aus, um es zu öffnen.
          </p>
        </div>

        <SicherheitPanel />

        {projects.length === 0 ? (
          <p className="text-center text-ink-muted">Noch keine Projekte angelegt.</p>
        ) : (
          <div className="flex flex-wrap items-start justify-center gap-x-10 gap-y-12">
            {projects.map((project) => (
              <ProjectCircle
                key={project.id}
                project={project}
                highlighted={project.id === lastVisitedId}
              />
            ))}
          </div>
        )}
      </section>

      {portalWidgets.map((Widget, index) => (
        <Widget key={index} />
      ))}
    </div>
  );
}
